import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lumiron-card-summary',
  templateUrl: 'card-summary.component.html',
  styleUrl: './card-summary.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class CardSummaryComponent {}
